// ==========================================
// Imports for core and plugin functionality
// ==========================================

import GLightbox from 'glightbox';
import Headroom from "headroom.js";
import AOS from 'aos';
import Lenis from 'lenis';
import Muuri from 'muuri';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import stickybits from 'stickybits';

// ==========================================
// Initialize GLightbox for image/video modals
// ==========================================
const lightbox = GLightbox();

// ==========================================
// Initialize Lenis for smooth scrolling
// ==========================================
const lenis = new Lenis({ autoRaf: true });
lenis.on('scroll', (e) => {
    // You can handle scroll position here if needed
});

// ==========================================
// Placeholder for Rellax initialization (parallax)
// ==========================================
let rellax;

// ==========================================
// DOMContentLoaded ensures DOM is ready before executing scripts
// ==========================================
document.addEventListener('DOMContentLoaded', function () {



    
    stickybits(".timeline__year-wrapper",{ useStickyClasses: true , stickyBitStickyOffset: 105 });

    // ==============================
    // Timeline Year Animation Block
    // ==============================
    const wrapper = document.getElementById('headline-wrapper');
    const numberEl = document.getElementById("timeline__year-number");

    if (wrapper && numberEl) {
        let currentYear = parseInt(numberEl.textContent, 10);
        let animating = false;

        // Toggle sticky class when wrapper hits top of viewport
        window.addEventListener("scroll", () => {
            const rect = wrapper.getBoundingClientRect();
            wrapper.classList.toggle("sticky-active", rect.top <= 0);
        });

        // Observe timeline year sections to trigger year change animation
        const sections = document.querySelectorAll(".timeline__year-section");
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !animating) {
                    const targetYear = parseInt(entry.target.getAttribute("data-year"), 10);
                    if (targetYear !== currentYear) {
                        animateYearChange(currentYear, targetYear);
                        currentYear = targetYear;
                    }
                }
            });
        }, { threshold: 0.6 });

        sections.forEach(section => observer.observe(section));

        // Animate year number change with blur transition
        function animateYearChange(from, to) {
            animating = true;
            numberEl.style.filter = "blur(2px)";
            const steps = 30;
            const delay = 20;
            let current = from;
            const direction = from < to ? 1 : -1;
            const stepSize = Math.max(1, Math.floor(Math.abs(to - from) / steps));

            const interval = setInterval(() => {
                current += direction * stepSize;

                if ((direction === 1 && current >= to) || (direction === -1 && current <= to)) {
                    current = to;
                    clearInterval(interval);
                    animating = false;
                    numberEl.style.filter = "blur(0)";
                }

                numberEl.textContent = current;
            }, delay);
        }
    }

    // ==============================
    // Headroom Initialization (Sticky Header)
    // Only if disable-headroom class is not present on body
    // ==============================
    if (!document.body.classList.contains('disable-headroom')) {
        const options = {
            offset: {
                up: 100,
                down: 100
            }
        };

        const element = document.querySelector("header");
        if (element) {
            const headroom = new Headroom(element, options);
            headroom.init();
        }
    }

    // ==============================
    // Handle horizontal text overflow scroll animation
    // ==============================
    $('.scroller').each(function () {
        const dealName = $(this).children('.nameSpan');
        const dealId = $(this).children('.idSpan');

        if (dealName.width() >= $(this).width()) {
            dealName.addClass('scrollTextAni');
        }
        if (dealId.width() >= $(this).width()) {
            dealId.addClass('scrollTextAni');
        }
    });

    // ==============================
    // Random color assignment to media wall circles
    // ==============================
    const circles = document.querySelectorAll(".media-wall__item-circle");
    circles.forEach(circle => {
        const randomColor = Math.floor(Math.random() * 5) + 1;
        circle.classList.add(`color-${randomColor}`);
    });

  

    // ==============================
    // Initialize Rellax for parallax scrolling
    // ==============================
    rellax = new Rellax('.rellax', {
        speed: -2,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
    });

    // ==============================
    // Initialize AOS for on-scroll animations
    // ==============================
    AOS.init();

    // ==============================
    // Initialize Muuri grid for media wall (filterable, draggable)
    // ==============================
    const gridElement = document.querySelector('.media-wall__grid');
    if (gridElement) {
        const grid = new Muuri(gridElement, {
            // Extend configuration if needed
        });

        // Filter buttons for Muuri grid
        const filterButtons = document.querySelectorAll('#filters button');
        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                const filterValue = button.getAttribute('data-filter');
                grid.filter(item => {
                    if (filterValue === 'all') return true;
                    return item.getElement().matches(filterValue);
                });
            });
        });
    }

    // ==============================
    // Accessible burger menu toggle for mobile
    // ==============================
    const siteNavigation = document.getElementById('site-navigation');
    if (siteNavigation) {
        const button = siteNavigation.querySelector('button');
        const menu = siteNavigation.querySelector('ul');

        if (button && menu) {
            if (!menu.classList.contains('nav-menu')) {
                menu.classList.add('nav-menu');
            }

            // Toggle menu on burger button click
            button.addEventListener('click', function () {
                siteNavigation.classList.toggle('toggled');
                const expanded = button.getAttribute('aria-expanded') === 'true';
                button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            });

            // Close menu on outside click
            document.addEventListener('click', function (event) {
                if (!siteNavigation.contains(event.target)) {
                    siteNavigation.classList.remove('toggled');
                    button.setAttribute('aria-expanded', 'false');
                }
            });

            // Accessibility focus handling
            const links = menu.querySelectorAll('a');
            const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

            links.forEach(link => {
                link.addEventListener('focus', toggleFocus, true);
                link.addEventListener('blur', toggleFocus, true);
            });

            linksWithChildren.forEach(link => {
                link.addEventListener('touchstart', toggleFocus, false);
            });

            /**
             * Toggles focus classes for accessibility and touch support on menus
             */
            function toggleFocus(event) {
                if (event.type === 'focus' || event.type === 'blur') {
                    let self = this;
                    while (self && !self.classList.contains('nav-menu')) {
                        if (self.tagName.toLowerCase() === 'li') {
                            self.classList.toggle('focus');
                        }
                        self = self.parentNode;
                    }
                }
                if (event.type === 'touchstart') {
                    const menuItem = this.parentNode;
                    event.preventDefault();
                    Array.from(menuItem.parentNode.children).forEach(link => {
                        if (menuItem !== link) {
                            link.classList.remove('focus');
                        }
                    });
                    menuItem.classList.toggle('focus');
                }
            }
        }
    }

        const videoBackground = document.getElementById("hero__video-bg");

        if (!videoBackground) {
        console.error("Element #videoBackground not found");
        return;
    }

    // Safety: re-check on load to ensure video dimensions are stabilized
    window.addEventListener("load", () => {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    console.log("Intersecting:", entry.isIntersecting, "Ratio:", entry.intersectionRatio);
                    if (entry.isIntersecting) {
                        videoBackground.classList.add("expanded");
                        observer.unobserve(entry.target); // Trigger once
                    }
                });
            },
            {
                root: null,
                threshold: 0.01, // very low to trigger on first visibility
                rootMargin: "0px"
            }
        );

        observer.observe(videoBackground);
    });
   

}); // End of DOMContentLoaded


document.addEventListener('scroll', () => {
    const gradient = document.querySelector('.top__gradient');
    const scrollThreshold = 50; // px, nach dem die Leiste verschwinden soll

    if (window.scrollY > scrollThreshold) {
        gradient.classList.add('top__gradient--hidden');
    } else {
        gradient.classList.remove('top__gradient--hidden');
    }

  
});


